import { SellerRoleInfo, SellerRoleInput } from 'src/WebApiController';

export const mapToSellerRoleInput = (roles?: SellerRoleInfo[] | null) => {
  return {
    id: -1,
    permissions: [...(roles?.flatMap((role) => role.permissions) ?? [])],
  } as SellerRoleInput;
};
